/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = window.csrfTokenValue;
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = window.csrfTokenValue;
}


/**
 * Import Foundation Components
 * check ./foundation.js if you need to enable more
 */
import Swiper from '../../node_modules/swiper/dist/js/swiper.js';
import './calculator';
import { Foundation } from './foundation';
//import Swiper from '../../node_modules/swiper/dist/js/swiper.js';


Foundation.addToJquery(jQuery);
require('parsleyjs');


/**
 * Application script
 */

// Initialize Foundation
$(document).foundation();

// Additional Logic
$(function() {

    // Add the GA tracking
    if($('#form-input-GCLID').length > 0) {
        document.getElementById("form-input-GCLID").value = (name = new RegExp('(?:^|;\\s*)gclid=([^;]*)').exec(document.cookie)) ? name.split(",")[1] : "";
    }
    // application form validation
    if ($('#applicationFormShort').length > 0) {
        
        // $('#applicationFormShort').parsley({
        //     "trigger": "focusout",
        //     "requiredMessage": "This field is required"
        // });

        // $('button[name=form_previous_page_button]').click(function() {
        //     $('#applicationFormShort').off('submit.Parsley');
        // });

        $("*[data-integer-only]").inputFilter(function(value) {
            return /^\d*$/.test(value);
        });

    }

    var swiper = new Swiper('.swiper-container', {
        spaceBetween: 30,
        effect: 'fade',

        fadeEffect: {
          crossFade: true,
        },

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

    });




});

(function($) {
    $.fn.inputFilter = function(inputFilter) {
      return this.on("input keydown keyup mousedown mouseup select contextmenu drop", function() {
        if (inputFilter(this.value)) {
          this.oldValue = this.value;
          this.oldSelectionStart = this.selectionStart;
          this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty("oldValue")) {
          this.value = this.oldValue;
          this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        }
      });
    };
  }(jQuery));


// WEBPACK FOOTER //
// ./public/js/app.js